import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Hero } from './components/Hero';
import { Products } from './components/Products';
import { About } from './components/About';
import { Newsletter } from './components/Newsletter';
import { MerchPage } from './pages/Merch';
import { ProductsPage } from './pages/Products';
import { CartProvider } from './context/CartContext';
import { CheckoutPage } from './pages/Checkout';
import { SplineLoader } from './components/SplineLoader';
import { LoadingScreen } from './components/LoadingScreen';
const HomePage = () => <Layout data-id="element-0">
    <Hero data-id="element-1" />
    <Products data-id="element-2" />
    <About data-id="element-3" />
    <Newsletter data-id="element-4" />
  </Layout>;
export function App() {
  const [showSpline, setShowSpline] = useState(true);
  const [showLoading, setShowLoading] = useState(true);
  if (showSpline) {
    return <SplineLoader onEnter={() => setShowSpline(false)} data-id="element-5" />;
  }
  if (showLoading) {
    setTimeout(() => setShowLoading(false), 2000);
    return <LoadingScreen data-id="element-6" />;
  }
  return <CartProvider data-id="element-7">
      <Router data-id="element-8">
        <Routes data-id="element-9">
          <Route path="/" element={<HomePage data-id="element-11" />} data-id="element-10" />
          <Route path="/merch" element={<MerchPage data-id="element-13" />} data-id="element-12" />
          <Route path="/products" element={<ProductsPage data-id="element-15" />} data-id="element-14" />
          <Route path="/checkout" element={<CheckoutPage data-id="element-17" />} data-id="element-16" />
        </Routes>
      </Router>
    </CartProvider>;
}